/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Title_2Inputs */

const en_svc_rag_title_2 = /** @type {(inputs: Svc_Rag_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`from your own documents.`)
};

const lv_svc_rag_title_2 = /** @type {(inputs: Svc_Rag_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`balstoties uz Jūsu dokumentiem.`)
};

/**
* | output |
* | --- |
* | "from your own documents." |
*
* @param {Svc_Rag_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_title_2 = /** @type {((inputs?: Svc_Rag_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_title_2(inputs)
	return en_svc_rag_title_2(inputs)
});